import React, { useState, useEffect } from "react";
import get from "lodash/get";
import Label from "components/Form/Label";
import TextInput from "components/Form/TextInput";
import NextButton from "../NextButton";
import PreviousButton from "../PreviousButton";
import Dropdown from "../../../components/Dropdown/Dropdown";
import { Countries } from "../../../consts/countries";
import ProgressBar from "../ProgressBar";

const Step = ({
  onChange,
  formData,
  languages,
  prevStep,
  nextStep,
  onUserSignUpByStep,
  currentStep,
  totalSteps,
}) => {
  const [hasError, setHasError] = useState(false);
  const [errorMessage, setErrorMessage] = useState({});

  const onFormValidation = (_data) => {
    let result = {};
    let hasInvalidInput = false;
    const phone = get(_data, "phone", "");
    const country = get(_data, "country", "");
    const language = get(_data, "language", "");

    if (!phone || phone.length <= 6) {
      hasInvalidInput = true;
      result.phone = "Please enter a phone number.";
    }

    if (!country) {
      hasInvalidInput = true;
      result.country = !country
        ? "Please enter a country."
        : "This field is required.";
    }

    if (!language) {
      hasInvalidInput = true;
      result.language = !language
        ? "Please enter a language."
        : "This field is required.";
    }

    setHasError(hasInvalidInput);
    setErrorMessage(result);
    return hasInvalidInput;
  };

  useEffect(() => {
    if (hasError) onFormValidation(formData);
  }, [hasError, formData]);
  return (
    <div className="mx-auto w-full lg:w-[480px]">
      <div>
        <h1 className="my-4 text-2xl md:text-3xl font-bold tracking-tight text-primary-700">
          Let’s talk 🤙
        </h1>
        <p className="mt-2 text-sm text-primary-700">
          Communication preferences.
        </p>
      </div>
      <div className="mt-8">
        <ProgressBar currentStep={currentStep} totalSteps={totalSteps} />
        <form action="#" method="POST" className="space-y-6">
          <div>
            <Label>Phone</Label>
            <TextInput
              id="phone"
              name="phone"
              type="number"
              autoComplete="phone"
              placeholder="(000) 000 0000"
              value={formData?.phone}
              onChange={(value) =>
                onChange({
                  ...formData,
                  phone: value,
                })
              }
              hasError={hasError ? get(errorMessage, "phone", "") : null}
              required
            />
            <div className="relative flex items-start mt-4">
              <div className="flex h-5 items-center">
                <input
                  id="sms"
                  aria-describedby="sms-description"
                  name="sms"
                  type="checkbox"
                  checked={formData?.sms_opt_in}
                  onChange={(event) => {
                    onChange({
                      ...formData,
                      sms_opt_in: event.target.checked,
                    });
                  }}
                  required
                  className="h-4 w-4 form-checkbox rounded border-gray-300 text-brand-500 focus:ring-brand-500"
                />
              </div>
              <div className="ml-3 text-sm">
                <label htmlFor="sms" className="font-medium text-gray-700">
                  Allow MagicLinks to send SMS messages
                </label>
                <p id="sms-description" className="text-gray-500">
                  We will notify only important updates and reminders.
                </p>
              </div>
            </div>
          </div>
          <div>
            <Label>Country/Region</Label>
            <Dropdown
              placeholder="Please select"
              options={Countries}
              value={Countries.find(
                (country) => country.value === formData?.country
              )}
              onChange={(selected) =>
                onChange({ ...formData, country: selected.value })
              }
              error={hasError ? get(errorMessage, "country", "") : null}
              required
            />
          </div>
          <div>
            <Label>Language</Label>
            <Dropdown
              placeholder="Please select"
              options={languages.map((language) => ({
                ...language,
                value: language.id,
              }))}
              value={languages.find(
                (language) => language.id === formData?.language
              )}
              onChange={(selected) => {
                onChange({ ...formData, language: selected.value });
              }}
              error={hasError ? get(errorMessage, "language", "") : null}
            />
          </div>

          <div className="w-full flex justify-between">
            <PreviousButton onClick={prevStep} />
            <NextButton
              onClick={() => {
                if (!onFormValidation(formData)) {
                  onUserSignUpByStep(nextStep);
                }
              }}
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default Step;
